import React, { createContext, useContext } from 'react';
import { useModules } from '@/hooks/useApi';

interface ModuleContextValue {
  enabledModules: Set<string>;
  isLoading: boolean;
  hasModule: (name: string) => boolean;
}

const ModuleContext = createContext<ModuleContextValue>({
  enabledModules: new Set(),
  isLoading: true,
  hasModule: () => false,
});

export const ModuleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data, isLoading } = useModules();
  const enabledModules = new Set(data?.enabled.map(m => m.name) ?? []);
  const hasModule = (name: string) => enabledModules.has(name);

  return (
    <ModuleContext.Provider value={{ enabledModules, isLoading, hasModule }}>
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleContext = () => useContext(ModuleContext);
